"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransformMiddlewares = (function () {
    function TransformMiddlewares() {
        this.styleMiddlewares = [];
        this.propsMiddlewares = [];
    }
    TransformMiddlewares.prototype.addStyleMiddleware = function (h) {
        this.styleMiddlewares.push(h);
    };
    TransformMiddlewares.prototype.addPropsMiddleware = function (h) {
        this.propsMiddlewares.push(h);
    };
    TransformMiddlewares.prototype.transformStyle = function (obj) {
        var newObj = Object.assign({}, obj);
        this.styleMiddlewares.forEach(function (middleware) {
            newObj = middleware(newObj);
        });
        return newObj;
    };
    TransformMiddlewares.prototype.transformProps = function (obj) {
        var newObj = Object.assign({}, obj);
        this.propsMiddlewares.forEach(function (middleware) {
            newObj = middleware(newObj);
        });
        return newObj;
    };
    return TransformMiddlewares;
}());
exports.default = new TransformMiddlewares();
//# sourceMappingURL=TransformMiddlewares.js.map